<template>
  <div>
    <div v-if="!loadStatus">
      <Skeleton width="100%" height="3.5rem" v-for="i in 15" :key="i" />
    </div>
    <template v-if="loadStatus">
      <div v-if="currentOrdersList.length > 0" class="order-list">
        <vue-good-table
          :totalRows="totalRecords"
          :columns="orderColumns"
          :rows="currentOrdersList"
          styleClass="vgt-table striped"
        >
          <template slot="table-row" slot-scope="currentOrdersList">
            <span v-if="currentOrdersList.column.field === 'createdAt'">
              <span>{{
                defaultFormatAndParse(currentOrdersList.row.processingStartDate)
              }}</span>
            </span>
            <span v-else-if="currentOrdersList.column.field === 'id'">
              <span>{{ currentOrdersList.row.orderId }}</span>
            </span>
            <span v-else-if="currentOrdersList.column.field === 'status'">
              <span v-if="currentOrdersList.row.trackingUrl">
                {{ currentOrdersList.row.status | Capitalize }} |
                <a :href="currentOrdersList.row.trackingUrl" target="_blank"
                  >Track</a
                >
              </span>
              <span v-else>{{
                currentOrdersList.row.status | Capitalize
              }}</span>
            </span>
            <span v-else-if="currentOrdersList.column.field === 'detailsUrl'">
              <router-link
                class="hoverable-text bold"
                :to="{
                  name: 'orderdetail',
                  params: { id: currentOrdersList.row.id, tab: 'MyOrders' }
                }"
                >View Details</router-link
              >
            </span>
          </template>
        </vue-good-table>
      </div>
      <div v-else>
        <OrderListZeroState />
      </div>
    </template>
    <Pagination
      :total-items="totalRecords"
      :page="serverParams.page"
      :items-per-page="serverParams.perPage"
      @page-change="pageChange"
      @perPageChange="handlePerPageChange"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus } from '../../helpers'
import { VueGoodTable } from 'vue-good-table'
import DateFns from '@/mixins/DateFns'

export default {
  name: 'MyOrderList',
  mixins: [DateFns],
  components: {
    VueGoodTable,
    OrderListZeroState: () => import('@/components/Orders/OrderListZeroState'),
    Skeleton: () => import('@/components/Universal/Skeleton'),
    Pagination: () => import('@/components/Universal/Pagination')
  },

  created() {
    this.$store.dispatch('globalTracking/changeSearchTerm', '')
    this.$store.dispatch('order/getMyOrdersList', { page: 1, perPage: 50 })
  },

  data() {
    return {
      awaitingSearch: false,
      serverParams: {
        page: 1,
        perPage: 50
      },
      orderColumns: [
        {
          label: 'Date',
          field: 'createdAt',
          sortable: true
        },
        {
          label: 'Order #',
          field: 'id',
          sortable: false
        },
        {
          label: 'Recipient',
          field: 'recipient.recipientName',
          sortable: false
        },
        {
          label: 'Sender Email',
          field: 'sender.attributes.email',
          sortable: false
        },
        {
          label: 'Ship Status',
          field: 'status',
          sortable: false
        },
        {
          label: 'Details',
          field: 'detailsUrl',
          sortable: false
        }
      ]
    }
  },

  methods: {
    pageChange(page) {
      this.updateParams({ page: page })
      this.getNextChuckOfOrders()
    },
    handlePerPageChange(e) {
      this.serverParams.perPage = e
      this.getNextChuckOfOrders()
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onColumnFilter(params) {
      this.updateParams(params)
      this.getNextChuckOfOrders()
    },
    getNextChuckOfOrders() {
      this.$store.dispatch('order/getMyOrdersList', {
        page: this.serverParams.page + 1,
        perPage: this.serverParams.perPage,
        nameOrEmail: this.searchTerm
      })
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.ordersListLoading)
    },
    ...mapState({
      searchTerm: state => state.globalTracking.searchTerm,
      ordersListLoading: state => state.order.ordersListLoading,
      currentOrdersList: state => state.order.currentOrdersList,
      totalRecords: state => state.order.totalRecords
    })
  },
  watch: {
    searchTerm(value) {
      this.updateParams({ page: 1 })
      this.$store.dispatch('order/getMyOrdersList', {
        page: 1,
        perPage: this.serverParams.perPage,
        nameOrEmail: value
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.order-list {
  // padding-top: 3rem;

  h1 {
    text-align: left;
  }
}
</style>
